
import { Component, Emit, Mixins, Prop, Watch } from 'vue-property-decorator'
import {
  Company,
  CompanyCollection, CompanyTypeEnum,
  User,
  UserRoleEnum
} from '@/firestore'
import AuthMixin from '@/mixins/AuthMixin.vue'
import axios from 'axios'

@Component
export default class AddExistingUserModal extends Mixins(AuthMixin) {
  @Prop({type: Boolean, default: false})
  public show!: boolean

  @Prop({type: Array, required: true})
  public roles!: Array<{ text: string, value: string }>

  public $refs!: {
    form: HTMLFormElement
  }

  public users: User[] = []
  public userDetails: User | null = null
  public selectedRole: UserRoleEnum | null = null
  public loadingUsers = false
  public savingUser = false

  @Watch('show')
  public async loadUsers() {
    if (this.show) {
      this.loadingUsers = true
      this.users = (await axios.get('/api/users', {
        params: {excludeCompanyId: [this.userCompany.id]}
      })).data
      this.loadingUsers = false
    }
  }

  @Emit()
  public async confirmSave() {
    await this.addSelectedUserToRestaurant()
    this.hide()
    this.saved()
  }

  @Emit()
  public hide() {
    this.$refs.form.reset()
  }

  @Emit()
  public saved() {
    this.$refs.form.reset()
  }

  private async addSelectedUserToRestaurant() {
    if (this.userDetails && this.selectedRole) {
      this.savingUser = true
      const {companyId, ...user} = this.userDetails
      user.companyRoles = {
        [this.userCompany.id]: this.selectedRole
      }
      await axios.put(`/api/users/${this.userDetails.id}`, user)
      this.savingUser = false
    }
  }
}
